import React from "react";
import ProductPage from "../../components/ProductPages/ProductPage";
import { PRODUCT_SCREENSHOTS } from "../../components/ProductPages/productScreenshots";
import { aiAssistStep } from "../../utility/aiAssistCopy";

const sections = [
  {
    title: "What average am I using?",
    body: "When a bowler asks, there is one answer. Enter or select the average at signup or when you add the team. Verify it once. Handicap and standings use that number on every squad they bowl.",
  },
  {
    title: "Import league sheets when you have a stack",
    body: "Upload league sheets into a list you review, then use on the tournament. You still verify when you need to.",
    to: "/bowling-tournament-average-import",
    linkLabel: "Average import",
  },
  {
    title: "Same number on every squad",
    body: "Handicap is a percent of the pins under the base, per game, from that verified average. It is zero when the average is at or above the base. Scratch tournaments score pinfall. Scoring, the recap, and standings use the same number.",
    to: "/bowling-tournament-scoring",
    linkLabel: "Scoring",
  },
];

const BowlingTournamentAverages = () => (
  <ProductPage
    title="Bowling Tournament Averages | Bowling Tournament App"
    description="Answer “what average am I using?” with one verified number. Enter it once. Handicap and standings use it on every squad."
    keywords={[
      "bowling tournament averages",
      "verify bowling averages",
      "bowling handicap averages",
      "bowling tournament average verification",
    ]}
    canonicalUrl="/bowling-tournament-averages"
    heading="One answer for “what average am I using?”"
    lede="Enter an average once. Verify it. Handicap and standings use that number on every squad."
    analyticsLocation="bowling_tournament_averages"
    secondaryTo="/bowling-tournament-scoring"
    secondaryLabel="Scoring"
    sectionHeading="One average for every squad"
    sections={sections}
    screenshot={PRODUCT_SCREENSHOTS.averages}
    importStep={aiAssistStep("averages")}
  />
);

export default BowlingTournamentAverages;
